export const GET_MAX_REACH_DATA = 'GET_MAX_REACH_DATA'
export const CLEAR_MAX_REACH_DATA = 'CLEAR_MAX_REACH_DATA'
export const SET_MAX_REACH_DATA = 'SET_MAX_REACH_DATA'
export const SET_MAX_REACH_ERROR = 'SET_MAX_REACH_ERROR'
export const SET_MAX_REACH_PROCESSING = 'SET_MAX_REACH_PROCESSING'

export function getMaxReachData (payload) {
  return {
    type: GET_MAX_REACH_DATA,
    payload,
  }
}

export function setMaxReachData (payload) {
  return {
    type: SET_MAX_REACH_DATA,
    payload,
  }
}

export function setMaxReachError (payload) {
  return {
    type: SET_MAX_REACH_ERROR,
    payload,
  }
}

export function setMaxReachProcessing (payload) {
  return {
    type: SET_MAX_REACH_PROCESSING,
    payload,
  }
}

export function clearMaxReachData (campaignId) {
  return {
    type: CLEAR_MAX_REACH_DATA,
    payload: { campaignId },
  }
}
